import { useCovi } from "../contexts/CoviContext"
import { SofiaOptionsMenu } from "./CoviPanelMenus"

export function SofiaHomeHeaderControls() {
  const { orgSlug } = useCovi()
  return <SofiaOptionsMenu orgSlug={orgSlug} />
}
